import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import * as serviceworker from './serviceWorker'

import "./translate/yupLocale";
import "./helpers/singleToast";
import App from "./App";

import "./assets/style.css";

const queryClient = new QueryClient();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>
);

serviceworker.register()
